import React from 'react';
import moment from 'moment';
import {
  CustomHeader,
  CompletedStatus,
  InProgressStatus,
  FailedStatus,
  HighAlert,
  GoodAlert,
  LowAlert,
  InQueueStatus,
  CentralContainer
} from './styled';
import { convertISOToDateFormat } from '../../../../../util/timezone';
import { toLower } from 'lodash';
import { MoreOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ActivityLogRiskIndiModel from '../activityLogRiskIndiModel';

const preventionAlertColors = (key, trmActions) => {
  if (key && trmActions) {
    let scoreKey = key.toLowerCase();
    let colorCodeLevels = Object.values(trmActions?.data || {});
    for (let level of colorCodeLevels) {
      if (
        level &&
        level.displayName &&
        level.displayName.toLowerCase() === scoreKey
      ) {
        if (level.alertLevel === 'High') return '#E94E43';
        if (level.alertLevel === 'Good') return '#EB922A';
        if (level.alertLevel === 'Low') return '#49C93D';
      }
    }
  }
  return '#00000';
};

export const columns = (trmActions, preventionResourceAccess) => {
  const result = [
    {
      title: <CustomHeader>Execution ID</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { id } = record;
        return <b>{id}</b>;
      }
    },
    {
      title: <CustomHeader>Execution Date</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { createdAt } = record;
        return <div>{convertISOToDateFormat(createdAt)}</div>;
      }
    },
    {
      title: <CustomHeader>Date Range</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { executionConfiguration } = record;
        const executionConfigurationParsed = JSON.parse(executionConfiguration);
        const { training, prediction } = executionConfigurationParsed;
        const { dateRange: trainingDateRange } = training || {};
        const { dateRange: predictionDateRange } = prediction || {};
        return (
          <>
            <div>{`Training - ${convertISOToDateFormat(
              trainingDateRange?.from
            )} - ${convertISOToDateFormat(trainingDateRange?.to)}`}</div>
            <div>{`Prediction - ${convertISOToDateFormat(
              predictionDateRange?.from
            )} - ${convertISOToDateFormat(predictionDateRange?.to)}`}</div>
          </>
        );
      }
    },
    {
      title: <CustomHeader>Status</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { status } = record;
        const lowerStatus = toLower(status);
        return (
          <>
            {lowerStatus === 'inprogress' && (
              <InProgressStatus>{status}</InProgressStatus>
            )}
            {lowerStatus === 'completed' && (
              <CompletedStatus>{status}</CompletedStatus>
            )}
            {lowerStatus === 'failed' && <FailedStatus>{status}</FailedStatus>}
            {lowerStatus === 'inqueue' && (
              <InQueueStatus>{status}</InQueueStatus>
            )}
          </>
        );
      }
    },
    {
      title: <CustomHeader>Alerts Count</CustomHeader>,
      dataIndex: 'totalAlert',
      key: 'totalAlert'
    },
    {
      title: <CustomHeader>Alerts Level</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { highAlert = 0, goodAlert = 0, lowAlert = 0 } = record;
        if (!preventionResourceAccess) {
          return (
            <>
              <HighAlert>{`High: ${highAlert}`}</HighAlert>
              <GoodAlert>{`Good: ${goodAlert}`}</GoodAlert>
              <LowAlert>{`Low: ${lowAlert}`}</LowAlert>
            </>
          );
        } else {
          const keys = Object.keys(record.levelsCount);
          return (
            <>
              {keys.map((key, index) => (
                <div
                  key={key}
                  style={{
                    color: preventionAlertColors(key, trmActions)
                  }}>
                  {key}: {record.levelsCount[key]}
                </div>
              ))}
            </>
          );
        }
      }
    }
  ];

  if (!preventionResourceAccess) {
    result.push({
      title: <CustomHeader>Risk Indicators</CustomHeader>,
      key: 'riskIndicators',
      render: ({ userThresholds = [] }) => {
        if (!preventionResourceAccess) {
          return (
            <CentralContainer>
              <ActivityLogRiskIndiModel userThresholds={userThresholds} />
            </CentralContainer>
          );
        }
      }
    });
  }

  return result;
};

export default columns;
